<template>
  <v-form v-model="valid" ref="form">
    <v-card color="#284e3c" class="white--text">
      <v-divider class="mx-2" inset horizontal></v-divider>
        <v-card-title>
          <v-icon color="white" large left>cloud_upload</v-icon>
          <span class="title font-weight-heavy">Create New User
            <button type="button" class="btn btn-secondary" data-toggle="tooltip" data-placement="left" title="Please fill in all fields to be able to make a user.">
                <v-icon color="white" large right>help_outline</v-icon>
            </button>
          </span>
        </v-card-title>
        <v-card-title>
          <span><v-text-field v-model="newuser.username" :rules="rules.name" class="title font-weight-heavy" color='white' label='Name:' autocomplete="new-password" required></v-text-field></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-text-field v-model="newuser.email" :rules="rules.email" class="title font-weight-heavy" color='white' label='Email:' autocomplete="new-password"></v-text-field></span>
        </v-card-title>
        <v-card-title>
          <span><v-text-field v-model="newuser.password" :rules="rules.password" class="title font-weight-heavy" type='password' color='white' label='Password:' autocomplete="new-password" required></v-text-field></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-text-field v-model="newuser.sms" type='phone' class="title font-weight-heavy" color='white' label='Contact Number:' autocomplete="new-password"></v-text-field></span>
        </v-card-title>
        <v-card-title>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span>
            <!-- two SaveUserBtn are for attempting to not allow user to save while Required Rule is in action -->
          <v-btn name="SaveUserBtn" v-on:click="SaveUser" :disabled="!valid" color="info">Save New User</v-btn>
          <v-btn name="CancelUserBtn" v-on:click="CancelUser" color="warning" type="submit">Cancel Changes</v-btn>
          </span>
        </v-card-title>
        <v-divider class="mx-2" inset horizontal></v-divider>
    </v-card>
  </v-form>
</template>
<script>
export default {
  computed: {
    rules () {
      return {
        name: [
          (v) => !!v || 'Name is required'
        ],
        password: [
          (v) => !!v || 'Password can not be empty.',
          (v) => !!(v.length >= 8) || 'Password must be greater than 8 characters.'
        ],
        email: [
          // eslint-disable-next-line no-useless-escape
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ]
      }
    }
  },
  name: 'NewUser',
  props: {
    userID: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    newuser: {
      username: '',
      password: '',
      sms: '',
      email: ''
    },
    valid: false,
    error: ''
  }),
  methods: {
    CancelUser () { // reloads page and doesnt make changes
      this.$router.go()
    },
    SaveUser () { // saves user to the database
      // eslint-disable-next-line no-console
      // console.log(`Creating NewUser: ${this.user.username}`)
      var url = `/schemas/users`
      this.$http
        .post(url,
          {
            'username': `${this.newuser.username}`,
            'password': `${this.newuser.password}`,
            'email': `${this.newuser.email}`,
            'sms': `${this.newuser.sms}`
          }
        )
        .then(response => {
          this.UserCreated(response.data.user)
        })
        .catch(error => this.requestFailed(error))
    },
    UserCreated (user) {
      // eslint-disable-next-line no-console
      // console.log(`Created NewUser: ${user.username}`)
      this.$router.go()
    },
    requestFailed (error) {
      this.error = 'Errors creating NewUser - check name is unqiue'
      // eslint-disable-next-line
      console.log(error)
      this.$parent.$emit('error', this.error)
    }
  }
}
</script>
